import { Button, Dialog, Tooltip } from '@cobliteam/ui/components';
import { Widget } from '@typeform/embed-react';

import { useUser } from '@cobliteam/hooks';

import { Analytics } from '@cobliteam/analytics';
import Icon from '@cobliteam/ui/icons';

const FeedbackButton = () => {
  const { user, session } = useUser();

  return (
    <Dialog>
      <Tooltip content='Dê sua opinião' asChild>
        <Dialog.Trigger asChild>
          <Button variant='outlined' color='default' size='sm' icon={<Icon name='megaphone' />} className='group' onClick={() => Analytics.track('NavBar - Feedback - Click')} />
        </Dialog.Trigger>
      </Tooltip>
      <Dialog.Content modalSize='lg'>
        <Dialog.Header>
          <Dialog.Title>Feedback</Dialog.Title>
          <Dialog.Close />
        </Dialog.Header>
        <Dialog.Body>
          <Widget
            id='xSep7a5p'
            className='h-[600px]'
            hidden={{
              email: user?.email || '',
              user_id: user?.id || '',
              name: user?.name || '',
              fleet_id: session?.fleet.id || '',
              fleet_name: session?.fleet.name || '',
            }}
          />
        </Dialog.Body>
      </Dialog.Content>
    </Dialog>
  );
};

export default FeedbackButton;
